import axios from 'axios';
import { BASE_URL } from '../../constants/env';

export const LOG_IN = async (e) => {
  const token = btoa(`${e.queryKey[1].userName}:${e.queryKey[1].password}`);
  const res = await axios.get(BASE_URL + `/admin/authenticate`, {
    headers: {
      Authorization: `Basic ${token}`,
    },
  });
  return res.data;
};

export const UNAUTHORIZE_USER = async () => {
  try {
    const res = await axios.post(BASE_URL + `/admin/unauthenticate`);
    return res.data;
  } catch (error) {
    console.log('error::', error);
  }
};
